enum EPromptType {
	loading = 'loading',
	success = 'success',
	error = 'error',
	neutral = 'neutral'
}

export { EPromptType };
